export function buildURLWithQueryString(url, params) {
  const existingParams = Object.fromEntries(Array.from(new URLSearchParams(window.location.search)));
  const queryString = createQueryString({...existingParams, ...params});
  const path = window.location.href.split('?')[0];

  return `${path}${queryString ? `?${queryString}` : ''}`;
}

function createQueryString(params) {
  const searchParams = new URLSearchParams();

  function processValue(key, value) {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach(item => {
        searchParams.append(`${key}[]`, item);
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        processValue(`${key}[${nestedKey}]`, nestedValue);
      });
    } else {
      searchParams.append(key, value);
    }
  }

  // Iterate through all params
  Object.entries(params).forEach(([key, value]) => {
    processValue(key, value);
  });

  return searchParams.toString();
}

// Option props arrive as { id: label } hashes, so their render order is whatever
// order JS enumerates the keys in — ascending numeric id, however the backend
// serialised them. Sorting belongs here rather than in the JSON anyway: admin
// options carry every translation at once, so only the view knows which
// alphabet applies. `locale` picks the translation out of a { ru, en } label and
// collates; plain string labels ignore it.
export function sortedOptionEntries(options, locale) {
  const label = ([, value]) => (typeof value === "string" ? value : value[locale]);

  return Object.entries(options).sort((a, b) => label(a).localeCompare(label(b), locale));
}
